require("./main.js");
